import React from 'react'
import styled from 'styled-components'
import { Flex, Image, Text } from '@crystals/uikit'
import { scroller } from 'react-scroll'
import { NavLink } from 'react-router-dom'
import { HamburgerIcon, HamburgerCloseIcon } from '../icons'
import MenuButton from './MenuButton'

interface Props {
  isPushed: boolean
  togglePush: () => void
  href: string
  isMobile: boolean
}

const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 30;
`

const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
  max-width: 1500px;
  ${({ theme }) => theme.mediaQueries.sm} {
    padding-left: 24px;
    padding-right: 24px;
  }
`

const LogoText = styled(Text)`
    // max-width: 768px;
    font-family: 'fs', sans-serif;
    color: #00e0b8;
    font-size: 30px;
    line-height: 1.0;
`

const Logo: React.FC<Props> = ({ isPushed, togglePush, href, isMobile }) => {
  const isAbsoluteUrl = href.startsWith('http')

  const scrollToTop = () =>
    scroller.scrollTo('top', {
      duration: 2000,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 50,
    })

  return (
    <Container>
      <Flex justifyContent="space-between" alignItems="center" width={isMobile ? '78vw' : 'auto'}>
        {isAbsoluteUrl ? (
          <StyledLink to="/" className="brand" aria-label="AITO.FINANCE">
            <Flex justifyContent="center" onClick={scrollToTop}>
              <div>
                <Image style={{ width: '180px' }} src="/images/Logo.png" alt="logo" width={200} height={50} ml="180px" />
              </div>
              {/* <LogoText>
                  BEST FLIP
              </LogoText> */}
            </Flex>
          </StyledLink>
        ) : (
          <StyledLink to="/" className="brand" aria-label="AITO.FINANCE">
            <Flex justifyContent="center" alignItems="center" onClick={scrollToTop}>              
              <div>
                <Image style={{ width: '180px' }} src="/images/Logo.png" alt="logo" width={80} height={80} />
                
              </div>
              <LogoText>
                  Shine CoinFLIP
              </LogoText>
            </Flex>
          </StyledLink>
        )}
        {isMobile && (
          <MenuButton
            aria-label="Toggle menu"
            onClick={togglePush}
            style={{ borderRadius: '50%', backgroundColor: '#07071c', width: '45px', height: '45px' }}
          >
            {isPushed ? (
              <HamburgerCloseIcon width="40px" color="rgba(255, 255, 255, 0.9)" />
            ) : (
              <HamburgerIcon width="40px" color="rgba(255, 255, 255, 0.9)" />
            )}
          </MenuButton>
        )}
      </Flex>
    </Container>
  )
}

export default Logo
